export const DirectionContentService = {
    'content': (<div className="location_content">
        <ul>
            <li className='md'>
                <h3>Step 1: Open Google Maps</h3>
                <p>Launch the <a className="link" target='_blank' href="https://www.google.com/maps">Google Maps</a> app or visit it in your web browser.</p>
            </li>
            <li className='md'>
                <h3>Step 2: Search for the Location</h3>
                <p>Type the name or address of the location in the search bar, then press “Enter” or tap the search icon.</p>
            </li>
            <li className='md'>
                <h3>Step 3: Select the Location</h3>
                <p>Once the location appears, click or tap the name in the info card at the bottom of the screen to open the details.</p>
            </li>
            <li className='md'>
                <h3>Step 4: Access the Share Option</h3>
                <p>On the details page, find the “Share” button. On the web, it’s next to the location name. In the app, it's below the description.</p>
            </li>
            <li className='md'>
                <h3>Step 5: Copy the Link</h3>
                <p>After clicking “Share,” select “Copy link.” The link is now saved to your clipboard and ready to paste.</p>
            </li>
        </ul>
    </div>),
}